export default "__VITE_ASSET__fbca40ca__"